// TODO Think of namings
export const getTrackingData = state => state.tracking.data;
export const getImpressionData = state => state.tracking.impression;
export const getTrafficSource = state => state.tracking.trafficSource;
